import { Container } from "./styles";

export const BotoesContainer = ({ children }) => {

    return (
        <Container>
            {children}
        </Container>
    )
}